import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=d2715180&"
import script from "./FaqCategory.vue?vue&type=script&lang=js&"
export * from "./FaqCategory.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FaqCategory.vue"
export default component.exports